import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { VerticalTabData } from "../../../../Data/UiKits/Tabs";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";

const VerticalTabContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {VerticalTabData &&
        VerticalTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};

export default VerticalTabContent;
